import React from "react";
import { Home } from "lucide-react";

const Breadcrumbs = ({ post }) => {
  return (
    <nav
      className="border-b border-slate-200 bg-slate-50 px-4 py-4"
      aria-label="Breadcrumb"
    >
      <ol className="mx-auto flex max-w-7xl flex-wrap items-center gap-2 text-sm font-medium text-gray-600">
        <li>
          <a
            href="/"
            className="inline-flex items-center gap-1 rounded-sm px-2 py-1 transition hover:bg-white hover:text-[rgb(126,34,206)]"
            aria-label="Home"
          >
            <Home className="h-4 w-4" aria-hidden="true" />
            <span className="sr-only">Home</span>
          </a>
        </li>
        <li className="text-slate-300">/</li>
        <li>
          <a
            href="/blog/"
            className="rounded-sm px-2 py-1 transition hover:bg-white hover:text-[rgb(126,34,206)]"
          >
            Blog
          </a>
        </li>
        {post?.category && (
          <>
            <li className="text-slate-300">/</li>
            <li>
              <a
                href={`/blog/category/${post.category}/`}
                className="rounded-sm px-2 py-1 transition hover:bg-white hover:text-[rgb(126,34,206)]"
              >
                {post.category}
              </a>
            </li>
          </>
        )}
        <li className="text-slate-300">/</li>
        <li className="min-w-0 flex-1 truncate text-gray-500">
          {post?.title}
        </li>
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
